import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import LexonTextAreaComponent from '@/components/forms/fields/LexonTextArea/LexonTextAreaComponent.vue'
import ChatFilterComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatFilterComponent.vue'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatComponent',
  props: {
  placeholder: {
    type: String,
    default: ''
  },
  modelValue: {
    type: String,
    default: ''
  },
  isLoading: {
    type: Boolean,
    default: false
  }
},
  emits: ['new-query', 'cancel-query'],
  setup(__props, { emit }) {

const props = __props;





const searchIAStore = useSearchIAStore()
const query = ref(props.modelValue)

watch(
  () => props.modelValue,
  (val) => {
    query.value = val
  }
)

const handleEnterKey = (event: KeyboardEvent) => {
  // Solo enviar si no está cargando
  if (!props.isLoading && query.value.trim()) {
    event.preventDefault()
    sendQuery()
  }
}

const handleButtonClick = async () => {
  if (props.isLoading) {
    emit('cancel-query')
    searchIAStore.resetSearchId()
  } else {
    await searchIAStore.generateSearchId()
    sendQuery()
  }
}

const sendQuery = () => {
  const filter = {
    type: searchIAStore.filterType || '',
    value: searchIAStore.filterValue
  }

  trackEvent(TrackerEvents.AI_SEARCH, {
    query: query.value,
    filter: filter.type !== '',
    filter_property_selected: filter.type === '' ? '' : filter.type,
    search_id: searchIAStore.search_id
  })
  emit('new-query', {
    query: query.value,
    filter: filter
  })
}

const sendIcon = require('@/assets/images/svg/icon-send.svg')
const stopIcon = require('@/assets/images/svg/icon-stop.svg')

return { __sfc: true,props, emit, searchIAStore, query, handleEnterKey, handleButtonClick, sendQuery, sendIcon, stopIcon, LexonTextAreaComponent, ChatFilterComponent }
}

})